module.exports = __webpack_public_path__ + "img/mycar.1a6ccf3b.png";